export class IFilterValues {
    id: string = "";
    value: string = "";
    description: string = "";
}

export interface ISelectedFilters {
    companies: Array<IFilterValues>;
    representatives: Array<string>;
    sbus: Array<IFilterValues>;
    serviceCodes: Array<string>;
    carriers: Array<IFilterValues>;
    flights: Array<IFilterValues>;
    originRegion: Array<IFilterValues>;
    originCountry: Array<IFilterValues>;
    portOfDeparture: Array<IFilterValues>;
    destinationRegion: Array<IFilterValues>;
    destinationCountry: Array<IFilterValues>;
    portOfArrival: Array<IFilterValues>;
    placeOfReceipt: Array<IFilterValues>;
    placeOfDelivery: Array<IFilterValues>;
    shipmentType: number;
    statusType: string;
}

export interface IFiltersCriteria {
    companies: Array<IFilterValues>;
    representatives: Array<string>;
    sbus: Array<IFilterValues>;
    serviceCodes: Array<IFilterValues>;
    carriers: Array<IFilterValues>;
    flights: Array<IFilterValues>;
    originRegion: Array<IFilterValues>;
    originCountry: Array<IFilterValues>;
    portOfDeparture: Array<IFilterValues>;
    destinationRegion: Array<IFilterValues>;
    destinationCountry: Array<IFilterValues>;
    portOfArrival: Array<IFilterValues>;
    placeOfReceipt: Array<IFilterValues>;
    placeOfDelivery: Array<IFilterValues>;
    shipmentType: number;
    statusType: string;
}

export interface IGraphOptions {
    id: string;
    graphType?: string;
    data?: any;
    container: string;
    color?: string;
    titleFontSize: string;
    toolTipUnit: string;
    height?: number;
    yAxisDiscription?: string;
}

export class SelectedFilters implements IFiltersCriteria {
    companies: [] = [];
    representatives: [] = [];
    sbus: [] = [];
    serviceCodes: [] = [];
    carriers: [] = [];
    flights: [] = [];
    originRegion: [];
    originCountry: [];
    portOfDeparture: [];
    destinationRegion: [];
    destinationCountry: [];
    portOfArrival: [];
    placeOfReceipt: [];
    placeOfDelivery: [];
    shipmentType: 0 = 0;
    statusType: "" = "";
}

export class EmptyFilters implements ISelectedFilters {
    companies = [];
    representatives = [];
    sbus = [];
    serviceCodes = [];
    carriers = [];
    flights = [];
    originRegion: [];
    originCountry: [];
    portOfDeparture: [];
    destinationRegion: [];
    destinationCountry: [];
    portOfArrival: [];
    placeOfReceipt: [];
    placeOfDelivery: [];
    shipmentType: 0 = 0;
    statusType: "" = "";
}
